var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * InterfaceFolderAdd component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconInterfaceFolderAdd extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.19634 3.77549C9.38155 3.77009 9.56302 3.8283 9.71054 3.94041C9.85806 4.05253 9.96272 4.21179 10.0071 4.39168L10.0077 4.39389L10.4915 6.32925C10.575 6.66312 10.875 6.89735 11.2191 6.89735H20.5837C20.7988 6.89735 21.005 6.98277 21.157 7.13482C21.3091 7.28686 21.3945 7.49309 21.3945 7.70812V19.4139C21.3945 19.6289 21.3091 19.8351 21.157 19.9872C21.005 20.1392 20.7988 20.2247 20.5837 20.2247H3.41526C3.20023 20.2247 2.99401 20.1392 2.84196 19.9872C2.68991 19.8351 2.60449 19.6289 2.60449 19.4139V4.58658C2.60449 4.37155 2.68991 4.16533 2.84196 4.01328C2.99401 3.86123 3.20023 3.77581 3.41526 3.77581H9.1745C9.18178 3.77581 9.18906 3.7757 9.19634 3.77549ZM10.6182 2.74617C10.2009 2.42905 9.68834 2.26327 9.16464 2.27581H3.41526C2.80241 2.27581 2.21465 2.51926 1.7813 2.95262C1.34795 3.38597 1.10449 3.97372 1.10449 4.58658V19.4139C1.10449 20.0267 1.34795 20.6145 1.7813 21.0478C2.21465 21.4812 2.80241 21.7247 3.41526 21.7247H20.5837C21.1966 21.7247 21.7843 21.4812 22.2177 21.0478C22.651 20.6145 22.8945 20.0267 22.8945 19.4139V7.70812C22.8945 7.09526 22.651 6.50751 22.2177 6.07416C21.7843 5.6408 21.1966 5.39735 20.5837 5.39735H11.8047L11.4634 4.03231L11.4631 4.03104C11.3364 3.51886 11.0383 3.06544 10.6182 2.74617ZM12.2026 10.0798C12.6168 10.0798 12.9526 10.4156 12.9526 10.8298V12.8113H14.9339C15.3481 12.8113 15.6839 13.1471 15.6839 13.5613C15.6839 13.9755 15.3481 14.3113 14.9339 14.3113H12.9526V16.2925C12.9526 16.7067 12.6168 17.0425 12.2026 17.0425C11.7884 17.0425 11.4526 16.7067 11.4526 16.2925V14.3113H9.47119C9.05698 14.3113 8.72119 13.9755 8.72119 13.5613C8.72119 13.1471 9.05698 12.8113 9.47119 12.8113H11.4526V10.8298C11.4526 10.4156 11.7884 10.0798 12.2026 10.0798Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconInterfaceFolderAdd.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceFolderAdd.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceFolderAdd.prototype, "size", void 0);
if (customElements.get('cat-icon-interface-folder-add') === undefined) {
    customElements.define('cat-icon-interface-folder-add', BlocksIconInterfaceFolderAdd);
}
